export const possibleGames = [
    {
        game: 211,
        lines: 20,
        name: "Chicago",
    }, {
        game: 198,
        lines: 10,
        name: "Sinbad",
    }, {
        game: 203,
        lines: 10,
        name: "India Night",
    }, {
        game: 206,
        lines: 20,
        name: "Pharaohs Artifact",
    }, {
        game: 207,
        lines: 10,
        name: "Rabbit Illusion",
    }, {
        game: 208,
        lines: 10,
        name: "Shaolino",
    }, {
        game: 210,
        lines: 10,
        name: "Arabian Delight",
    }, {
        game: 222,
        lines: 10,
        name: "Dolphins Lagoon",
    },
];